import React from "react";
import { useAuth } from "./contexts/AuthContext";
import { KeyRound } from "lucide-react";
import config from "./config.js";

function Login() {
  const { signIn, error } = useAuth();

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 dark:bg-gray-900 relative">
      <div
        className="bg-white dark:bg-slate-800 shadow-lg rounded-lg p-8 flex flex-col items-center"
        style={{ maxWidth: "400px", width: "100%" }}
      >
        {/* Logo and Branding (matches navbar) */}
        <div className="flex items-center gap-3 mb-2">
          {config.brandLogoUrl && (
            <img
              src={config.brandLogoUrl}
              alt={config.brandName}
              className="select-none dark:invert"
              style={{
                height: `${48 * config.brandLogoScale}px`,
                width: 'auto',
                maxWidth: '200px',
                objectFit: 'contain'
              }}
            />
          )}

          <div className="flex flex-col gap-0.5">
            <span
              className="text-[18px] font-bold font-sans tracking-tight text-gray-900 dark:text-white leading-none"
              style={{
                fontFamily:
                  'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              }}
            >
              {config.brandName}
            </span>
            <span
              className="text-[18px] font-medium font-sans tracking-wide text-gray-900 dark:text-white leading-none pl-4"
              style={{
                fontFamily:
                  'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              }}
            >
              {config.brandTagline}
            </span>
          </div>
        </div>

        {error && (
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded text-sm mb-4 w-full text-center"
            role="alert"
          >
            {error}
          </div>
        )}

        <button
          className="w-full px-4 py-2 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors flex items-center justify-center gap-2 mt-2"
          onClick={signIn}
        >
          <KeyRound className="w-4 h-4" /> Sign in with SSO
        </button>
      </div>
    </div>
  );
}

export default Login;
